import { observer } from "mobx-react"
import { useEffect } from "react"
import AppStore from "../../Configs/Stores/AppStore"
import LazyScript from "../Common/LazyScript"

const ExtraHeader = observer(() => {

  useEffect(() => {
    AppStore.setAppLoaded(true)
  }, [])

  // const isLocalHost = false

  const isLocalHost = window.location.hostname === "localhost"

  // HEAD //
 const SHAMIN_JS = "https://www.iciciprulife.com/content/icici-prudential-life-insurance/term-insurance-plans/assets_iPS_new/liabraries/sha.min.js"


  return (
    <>
      {!isLocalHost && (
        <>
          <LazyScript id="SHAMIN_JS" target="head" src={SHAMIN_JS} defer={true} />  
        </>
      )}
    </>
  )
})

export default ExtraHeader
